import { useEffect, useState } from 'react';

type Props = {
  name: string;
  spectator: boolean;
  onRename: (name: string) => void;
  onSpectatorChange: (spectator: boolean) => void;
  onLeave: () => void;
};

export const YouBar = ({ name, spectator, onRename, onSpectatorChange, onLeave }: Props) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(name);

  useEffect(() => {
    if (!editing) setDraft(name);
  }, [name, editing]);

  const commit = () => {
    setEditing(false);
    const trimmed = draft.trim();
    if (trimmed && trimmed !== name) onRename(trimmed);
    else setDraft(name);
  };

  return (
    <div className="you-bar">
      {editing ? (
        <form
          className="you-name-form"
          onSubmit={(event) => {
            event.preventDefault();
            commit();
          }}
        >
          {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
          <input
            autoFocus
            value={draft}
            maxLength={32}
            onChange={(event) => setDraft(event.target.value)}
            onBlur={commit}
          />
        </form>
      ) : (
        <button type="button" className="you-name" onClick={() => setEditing(true)} title="Rename">
          {name} <span className="you-pencil">✎</span>
        </button>
      )}

      <label className="switch">
        <input
          type="checkbox"
          checked={spectator}
          onChange={(event) => onSpectatorChange(event.target.checked)}
        />
        <span className="switch-track" aria-hidden="true" />
        <span>Spectator</span>
      </label>

      <button type="button" className="btn btn-ghost btn-sm" onClick={onLeave}>
        Leave
      </button>
    </div>
  );
};
